export const OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL';
export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL';
export const SET_CURRENT_AUTH_MODAL_FORM = 'SET_CURRENT_AUTH_MODAL_FORM';
